import { render, staticRenderFns } from "./ThemeDetails.vue?vue&type=template&id=0fce22f0&"
import script from "./ThemeDetails.vue?vue&type=script&lang=ts&"
export * from "./ThemeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports